import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, Router, RouterStateSnapshot } from '@angular/router';

import { ScrollService } from '@app/common/services/scroll.service';

@Injectable({
  providedIn: 'root'
})
export class ScrollableRouteGuard implements CanActivate {
  private router = inject(Router);
  private scrollService = inject(ScrollService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    switch (state.url) {
      case '/realizacje':
        this.scrollService.requestScrollToElement('portfolio');
        break;
      case '/proces':
        this.scrollService.requestScrollToElement('process');
        break;
      case '/faq':
        this.scrollService.requestScrollToElement('faq');
        break;
      case '/kontakt':
        this.scrollService.requestScrollToElement('contact');
        break;
    }

    return this.router.parseUrl('/');
  }
}
